export default __webpack_public_path__ + "static/media/image-work-company-w.a81ac57e.webp";